"use client"

import { Translate } from "@/components/translate"
import { Img } from "@/components/ui/image"

const CallUs = () => {
  return (
    <div className="mb-6 flex w-full flex-wrap items-center gap-4 px-3 md:basis-1/2">
      <a
        href="tel:800.999.445"
        rel="noopener noreferrer"
        target="_blank"
        className="contactIcon flex size-16 items-center justify-center rounded-full bg-btn-primary md:size-20"
      >
        <Img
          alt="phone"
          src="/assets/error-page/phone.svg"
          width={1}
          height={1}
          className="size-10 md:size-16"
        />
      </a>
      <a
        href="tel:800.999.445"
        rel="noopener noreferrer"
        target="_blank"
        className="contact-caption callInfo font-primary font-bold"
      >
        <span className="contactTitle text-paragraph-s">
          <Translate i18nKey="ErrorPage.callUs" />
        </span>
        <br />
        <span className="contact-content text-title-xl">
          <u>800.999.445</u>
        </span>
      </a>
    </div>
  )
}

export { CallUs }
